module.exports = __webpack_public_path__ + "img/logo_grosirone.e46a71de.png";